import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

import 'jquery-ui';
import 'jquery-match-height';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'slick-carousel';
